import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { offersHistory } from './types';
import { requestOffersHistoryFailure, requestOffersHistorySuccess } from './reducer';

const logger = new Logger('Saga:FundingSearchOffersHistory');

export function* requestOffersHistorySaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.funding_matches_offers_history', {
        matchId: action.matchId,
      }),
    );

    action.promise && action.promise.resolve(response.data);
    yield put(requestOffersHistorySuccess(action.matchId, response.data));
  } catch (error) {
    logger.error('Failed to request funding search offers history with the following error', error);
    yield put(requestOffersHistoryFailure(action.matchId, error));
    action.promise && action.promise.reject(error);
  }
}

export default function* fundingSearchSaga() {
  return yield all([takeLatest(offersHistory.request, requestOffersHistorySaga)]);
}
